<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>{{ 'service.survey-service.question-final-decision-statuses.revised_split.title' | translate }}</span>
    <span class="spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="close()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content>
  @for (question of newQuestions; track question; let i = $index) {
    <div class="mb-4">
      <app-single-question [question]="question" [clonable]="false" [editable]="true"
      [isResponse]="false"></app-single-question>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="center" class="dialog-actions-buttons">
  <button mat-stroked-button class="text-dark-purple border-purple mr-2" (click)="close()">{{ 'generic.cancel' | translate }}</button>
  <button mat-raised-button color="primary" (click)="save()"><mat-icon>save</mat-icon>{{ 'generic.buttons.save' | translate }}</button>
</mat-dialog-actions>
